export default class BlockBookNow {
    constructor(container, options) {
        const defaultOptions = {
            bookNowButton: '.btn-block-book-now',
            datepicker: '.flatpickr',
            bookingLinkDefault: '',
            bookingLinkWithVenue: '',
            urlFormat: 'default'
        };
        this.options = Object.assign({}, defaultOptions, options);
        this.container = document.querySelector(container);
        this.bookNowButton = this.container.querySelector(this.options.bookNowButton);
        this.datePicker = this.container.querySelector(this.options.datepicker);
        this.selectedDate = null;

        this.bookingLinkDefault = options.bookingLinkDefault;
        this.bookingLinkWithVenue = options.bookingLinkWithVenue;

        this.initDatePicker();
        this.setEvents();
    }

    setEvents() {
        this.bookNowButton.addEventListener('click', this.openBlockBookNowPage.bind(this));
    }

    openBlockBookNowPage() {
        const venue = this.getVenue();
        const venueId = venue.dataset.venue; 
        const venueName = venue.querySelector(".input-text").innerText;
        const date = this.selectedDate;
        
        if(venueId === null || venueId === '') {
            return;
        }

        let parameters = '';
        let bookLinkPrefix = this.bookingLinkDefault;
        let bookLinkTarget = '_blank';
        if(this.options.urlFormat === 'PNL') {
            if (venueId !== null && venueId !== '') {
                bookLinkPrefix = `${this.bookingLinkWithVenue}/${venueId}`;
            }
        }
        else {
            if (venueId !== null && venueId !== '') {
                bookLinkPrefix = this.bookingLinkWithVenue;
                parameters += `venue=${venueId}`;
            }
            if(date !== null) {
                if(parameters !== '') {
                    parameters += '&';
                }
                parameters += `year=${date.year}&month=${date.month}&day=${date.day}`;
            }
            if(typeof this.bookNowButton.dataset.url !== 'undefined' && this.bookNowButton.dataset.url !== '') {
                bookLinkPrefix = this.bookNowButton.dataset.url;
            }
            if(typeof this.bookNowButton.dataset.urlTarget !== 'undefined' && this.bookNowButton.dataset.urlTarget !== '') {
                bookLinkTarget = this.bookNowButton.dataset.urlTarget;
            }
        }
        
        let bookLink = bookLinkPrefix;
        if(parameters !== '') {
            bookLink = bookLinkPrefix + '?' + parameters;
        }

        this.bookNowButton.dataset.dstapiVenue = venueName;

        window.open(bookLink, bookLinkTarget).focus();        
    }
    
    initDatePicker() {
        flatpickr(this.datePicker, {
            minDate: "today",
            dateFormat: "D, d M Y",
            disableMobile: false,
            locale: {
                firstDayOfWeek: 1 // start week on monday
            },
            onOpen: () => {
                let flatpickrWeekday = document.querySelectorAll('.flatpickr-weekday')
                flatpickrWeekday.forEach(day => {
                    day.innerHTML = day.innerHTML.trim().slice(0, 1)
                });
            },
            onChange: (dateObj, dateStr) => {
                const dateArr = dateStr.replaceAll(',', '').split(' ')
                const monthStr = ("JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dateArr[2]) / 3 + 1)

                const venueBook = {
                    year: dateArr[3],
                    month: monthStr,
                    day: dateArr[1]
                }

                this.selectedDate = venueBook;
            }
        })
    }
    
    getVenue() {
        return this.container.querySelector('.select-venue');
    }
}